@if (loading$ | async) {
  <wre-toolkit-loader></wre-toolkit-loader>
}

@if (!(loading$ | async)) {
  <div>
    @if (displayError) {
      <div class="p-3">Failed to retrieve tools.</div>
    }
    @if (!displayError) {
      <div #tableContainer class="table-responsive apps-table">
        <table class="table wre-table fixed-column mb-0">
          <thead>
            <tr>
              <th class="fixed-column action">&nbsp;</th>
              <th class="active text-center">Active</th>
              <th class="order text-center">Order No.</th>
              <th class="new text-center">New Tool</th>
              <th class="new-tab text-center">Open in new tab</th>
              <th class="is-tool text-center">Is Tool</th>
              <th class="off-vpn text-center">Available Off Vpn</th>
              <th class="workspace">Workspace</th>
              <th class="name">Name</th>
              <th class="url">Url</th>
              <th class="security-group">Security Roles</th>
            </tr>
          </thead>
          <tbody class="mb-0 pb-0">
            @for (app of apps; track app) {
              <tr>
                <td class="fixed-column action">
                  <div ngbDropdown container="body">
                    <button class="btn btn-secondary" ngbDropdownToggle>Action</button>
                    <div ngbDropdownMenu>
                      @if (hasEditPermission) {
                        <button ngbDropdownItem (click)="onEdit(app)">Edit</button>
                        <button ngbDropdownItem (click)="onEnableDisableApp(app)">
                          {{ app.isActive ? 'Disable' : 'Enable' }}
                        </button>
                      }
                      @if (hasDeletePermission) {
                        <button ngbDropdownItem (click)="onDelete(app)" class="delete">
                          Delete
                        </button>
                      }
                    </div>
                  </div>
                </td>
                <td class="active text-center">
                  @if (app.isActive) {
                    <i
                      class="fa fa-check wre-gateway-web-apps-color-icon-fa-check"
                      aria-hidden="true"></i>
                  } @else {
                    <i
                      class="fa fa-times wre-gateway-web-apps-color-icon-fa-times"
                      aria-hidden="true"></i>
                  }
                </td>
                <td class="order text-center">{{ app.orderNo }}</td>
                <td class="new text-center">
                  @if (app.isNew) {
                    <i
                      class="fa fa-check wre-gateway-web-apps-color-icon-fa-check"
                      aria-hidden="true"></i>
                  } @else {
                    <i
                      class="fa fa-times wre-gateway-web-apps-color-icon-fa-times"
                      aria-hidden="true"></i>
                  }
                </td>
                <td class="new-tab text-center">
                  @if (app.openInNewTab) {
                    <i
                      class="fa fa-check wre-gateway-web-apps-color-icon-fa-check"
                      aria-hidden="true"></i>
                  } @else {
                    <i
                      class="fa fa-times wre-gateway-web-apps-color-icon-fa-times"
                      aria-hidden="true"></i>
                  }
                </td>
                <td class="is-tool text-center">
                  @if (app.isTool) {
                    <i
                      class="fa fa-check wre-gateway-web-apps-color-icon-fa-check"
                      aria-hidden="true"></i>
                  } @else {
                    <i
                      class="fa fa-times wre-gateway-web-apps-color-icon-fa-times"
                      aria-hidden="true"></i>
                  }
                </td>
                <td class="off-vpn text-center">
                  @if (app.isAvailableOffVpn) {
                    <i
                      class="fa fa-check wre-gateway-web-apps-color-icon-fa-check"
                      aria-hidden="true"></i>
                  } @else {
                    <i
                      class="fa fa-times wre-gateway-web-apps-color-icon-fa-times"
                      aria-hidden="true"></i>
                  }
                </td>
                <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="workspace">
                  {{ app.category?.name }}
                </td>
                <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="name">
                  {{ app.name }}
                </td>
                <td class="url">
                  <a target="_blank" rel="noopener" title="{{ app.url }}" href="{{ app.url }}"
                    >Link</a
                  >
                </td>
                <td wreToolkitTitleWhenTruncated ngbTooltip container="body" class="security-group">
                  @for (role of app.securityRoles; track role; let first = $first) {
                    <span>
                      <span [ngClass]="{ 'ms-2 ps-2 border-start': !first }">
                        {{ role.name }}
                      </span>
                    </span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
}
